import React, {Component} from "react";
import "./MonthlyReport.scss"
import GroupNav from '../DownloadReport/GroupNav';
import DatePicker from 'react-datepicker';
import moment from "moment";
import {schemaTypes} from '../../../../constants/constants'
import ReportAPIs from "../../../../APIs/ReportAPIs";
import GroupTable from '../GroupReport/groupTable';
import ReusableGraph from '../ReusableGraph/ReusableGraph';
import { JSONToCSVConvertor } from '../../../../helpers/helperFunctions';

class MonthlyReport extends Component{
    constructor(props){
        super(props)
        this.props = props
        this.state = {
            utilization_type: "",
            reportName: "",
            dropdownOpen: false,
            startDate: moment().subtract(1, "month").startOf("day").toDate(),
            endDate: moment().subtract(1, "day").endOf("day").toDate(),
            selectAllGroups: false,
            groups: [],
            selectedGroup: {},
            vehicleIds: [],
            tableData: [],
            columns: [],
            graphData: null,
            busy: false,
            errorPage: false,
            canDownload: false,
        }
        this.group = []
        
        // Header name mapping: API key -> Display name
        this.headerMapping = {
            'regno': 'Reg No',
            'vinno': 'VIN No',
            'make': 'Make',
            'model': 'Model',
            'month': 'Month',
            'totaldistance': 'Total Distance(KM)',
            'totalsoconsumed': 'Total SoC Consumed(%)',
            'startodometer': 'Start Odometer(KM)',
            'endodometer': 'End Odometer(KM)',
            // Add more mappings as needed
        };
    }

    componentDidMount(){
        this.handleClickOutside = (e) => {
            let container = document.querySelector('.mrc-report-type');
            if (container && !container.contains(e.target)) {
                this.setState({dropdownOpen: false});
            }
        };
        document.addEventListener('mousedown', this.handleClickOutside);
        
        // Fix gap between tabs and content
        window.$('.rw-container').css('top', '53px');

        // Initialize group tree (without collecting vehicles)
        let group = this.props.props.groupTree;
        if(!group.path){
            group.path = "/0/";
            group.ppath = "/0/";
        }
        this.group = group;
        // Initialize groups state without navigating (no vehicle collection on load)
        let rootGroupPath = "";
        let nav = [];
        nav.push(this.group);
        this.setState({groups: nav});
    }

    componentWillUnmount() {
        if (this.handleClickOutside) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
        
        // Remove the top style when component unmounts
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
    }

    toggleDropdown = () => {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    };

    handleOptionClick = (value, name) => {
        this.setState({
            utilization_type: value,
            reportName: name,
            dropdownOpen: false,
        });
    };

    getReportType = () => {
        const reportTypes = [
            { key: "utilization-report", name: "Utilization Report" },
            { key: "utilization-graph", name: "Utilization Graph" }
        ];
        
        return reportTypes.map((report, index) => {
            return (
                <div
                    key={index}
                    className="dropdown-option"
                    onClick={() => this.handleOptionClick(report.key, report.name)}
                >
                    {report.name}
                </div>
            );
        });
    };

    handleStartDate = (date) => {
        // Set start date to 00:00 (midnight) of the selected date
        const startDateWithTime = moment(date).startOf("day").toDate();
        this.setState({startDate: startDateWithTime})
    }

    handleEndDate = (date) => {
        // Set end date to 23:59 (11:59 PM) of the selected date
        const endDateWithTime = moment(date).endOf("day").toDate();
        this.setState({endDate: endDateWithTime})
    }

    // Recursively collect vehicle IDs from a group and all its sub-groups
    collectVehicleIdsFromGroup = (group) => {
        let vehicleIds = [];
        
        if (!group) {
            return vehicleIds;
        }

        // Collect vehicles from current group
        if (group.vehicles && Array.isArray(group.vehicles)) {
            group.vehicles.forEach(vehicle => {
                const vehicleId = vehicle.id || vehicle.vehicleid || vehicle.userid;
                if (vehicleId) {
                    vehicleIds.push(vehicleId);
                }
            });
        }

        // Recursively collect vehicles from all sub-groups
        if (group.children && Array.isArray(group.children)) {
            group.children.forEach(childGroup => {
                if (childGroup.groupid != null) {
                    const childVehicleIds = this.collectVehicleIdsFromGroup(childGroup);
                    vehicleIds = [...vehicleIds, ...childVehicleIds];
                }
            });
        }

        return vehicleIds;
    }

    navigate = (group) => {
        let rootGroupPath = "";
        let path = group.path;
        let pathArray = path.split("/");
        pathArray.splice(0,1);
        pathArray = pathArray.splice(0, pathArray.length-1);
        let currentPath = rootGroupPath;
        let nav = [];
        let currentNode = this.group;
        nav.push(currentNode);
        for(let idx in pathArray){
            currentPath += "/" + pathArray[idx];
            for(let jdx in currentNode.children){
                if(currentNode.children[jdx].path === currentPath + "/"){
                    currentNode = currentNode.children[jdx];
                    if(!("children" in currentNode))
                        currentNode.children = [];
                    nav.push(currentNode);
                    break;
                }
            }
        }
        
        // Collect vehicle IDs from the selected group and all its sub-groups
        const vehicleIds = this.collectVehicleIdsFromGroup(group);
        
        this.setState({groups: nav, selectedGroup: group, vehicleIds: vehicleIds});
    }

    toggleSelectAllGroups = () => {
        const newSelectAllGroups = !this.state.selectAllGroups;
        
        if (newSelectAllGroups) {
            // Collect all vehicles from the main group tree and all sub-groups
            const vehicleIds = this.collectVehicleIdsFromGroup(this.group);
            this.setState({
                selectAllGroups: true, 
                vehicleIds: vehicleIds,
                selectedGroup: {} // Clear selected group when selecting all
            });
        } else {
            // Clear vehicle IDs and selected group when unchecking
            this.setState({
                selectAllGroups: false, 
                vehicleIds: [],
                selectedGroup: {}
            });
        }
    }

    // Validate if all required fields are filled
    isFormValid = () => {
        // Check if group/vehicles are selected
        // Either "Select All Groups" is checked OR a specific group is selected (with valid groupid)
        const hasGroupOrVehicles = this.state.selectAllGroups || 
            (this.state.selectedGroup && 
             this.state.selectedGroup.groupid !== undefined && 
             this.state.selectedGroup.groupid !== null &&
             Object.keys(this.state.selectedGroup).length > 0);
        
        // Check if start date is selected
        const hasStartDate = this.state.startDate !== null && this.state.startDate !== undefined;
        
        // Check if end date is selected
        const hasEndDate = this.state.endDate !== null && this.state.endDate !== undefined;
        
        // Check if report type is selected
        const hasReportType = this.state.utilization_type !== "" && 
                             this.state.utilization_type !== null && 
                             this.state.utilization_type !== undefined;
        
        return hasGroupOrVehicles && hasStartDate && hasEndDate && hasReportType;
    }

    // Process API response and generate columns dynamically
    processResponseData = (response) => {
        if (!response || !Array.isArray(response) || response.length === 0) {
            return { data: [], columns: [] };
        }

        // Get all unique keys from the response objects
        const allKeys = new Set();
        response.forEach(item => {
            Object.keys(item).forEach(key => allKeys.add(key));
        });

        // Generate columns from keys with header mapping
        const columns = Array.from(allKeys).map(key => {
            // Check if there's a mapping for this key
            const mappedName = this.headerMapping[key.toLowerCase()];
            
            // If mapping exists, use it; otherwise format the key
            const displayName = mappedName || 
                (key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '));
            
            return {
                key: key,
                name: displayName
            };
        });

        // Format data - ensure all items have all keys (fill missing with empty string)
        const data = response.map(item => {
            const formattedItem = {};
            columns.forEach(col => {
                formattedItem[col.key] = item[col.key] !== undefined && item[col.key] !== null 
                    ? item[col.key] 
                    : '';
            });
            return formattedItem;
        });

        return { data, columns };
    }

    // Process graph data from API response
    processGraphData = (response) => {
        // Handle both direct array and object with data property
        let data = null;
        if (Array.isArray(response)) {
            data = response;
        } else if (response && response.data && Array.isArray(response.data)) {
            data = response.data;
        }
        
        if (!data || data.length === 0) {
            return null;
        }
        
        // Extract dates for x-axis
        const dates = data.map(item => item.date || moment(item.daystarttime).format('DD-MMM-YYYY'));
        
        // Extract data for each series
        const totalOdometer = data.map(item => item.totalodometer || 0);
        const totalDistance = data.map(item => item.totaldistance || 0);
        const totalSoConsumed = data.map(item => item.totalsoconsumed || 0);

        return {
            dates,
            totalOdometer,
            totalDistance,
            totalSoConsumed
        };
    }

    // Get graph configuration for ReusableGraph component
    getGraphConfig = () => {
        const { graphData } = this.state;
        
        if (!graphData) {
            return null;
        }

        return {
            type: 'mixed', // Mixed line and bar chart
            data: graphData.dates, // X-axis data
            xAxisData: graphData.dates,
            series: [
                {
                    name: 'Total Odometer',
                    type: 'line',
                    yAxisIndex: 0,
                    data: graphData.totalOdometer,
                    smooth: true,
                    itemStyle: {
                        color: '#5470c6'
                    }
                },
                {
                    name: 'Total Distance',
                    type: 'bar',
                    yAxisIndex: 1,
                    data: graphData.totalDistance,
                    itemStyle: {
                        color: '#91cc75'
                    }
                },
                {
                    name: 'Total SoC Consumed',
                    type: 'bar',
                    yAxisIndex: 1,
                    data: graphData.totalSoConsumed,
                    itemStyle: {
                        color: '#fac858'
                    }
                }
            ],
            options: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                grid: {
                    bottom: 150, // Add more bottom padding to accommodate rotated labels and legend
                    left: 60,
                    right: 60,
                    top: 60
                },
                legend: {
                    data: ['Total Odometer', 'Total Distance', 'Total SoC Consumed'],
                    bottom: 0 // Position legend at the very bottom
                },
                xAxis: {
                    rotate: 90, // Rotate labels 90 degrees (vertical)
                    interval: 0, // Show all labels (no skipping)
                    axisLabel: {
                        margin: 10 // Add margin between labels and axis
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'Total Odometer',
                        position: 'left',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    {
                        type: 'value',
                        name: 'Distance / SoC',
                        position: 'right',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    }
                ]
            }
        };
    }

    downloadReport = () => {
        const { tableData, columns, utilization_type, graphData } = this.state;

        const toast = (name, content, showError = false) => {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                    name,
                    content,
                    createAt: Date.now(),
                    autoClose: 4000,
                    showError
                },
            });
        };

        // No data guard
        if (utilization_type === "utilization-report") {
            if (!tableData || !tableData.length) {
                toast("No Data", "No table data available to download.", true);
                return;
            }

            // Build rows using column display names
            let rows = [];
            const cols = (columns && columns.length) ? columns : Object.keys(tableData[0] || {}).map(k => ({ key: k, name: k }));
            tableData.forEach(item => {
                let row = {};
                cols.forEach(col => {
                    row[col.name || col.key] = item[col.key];
                });
                rows.push(row);
            });

            const stamp = moment().format("YYYYMMDD_HHmmss");
            JSONToCSVConvertor(rows, `Utilization_Report_${stamp}`, false, true, false);
            toast("Download", `Utilization report downloaded (${stamp}).`);
        } else if (utilization_type === "utilization-graph") {
            if (!graphData) {
                toast("No Data", "No graph data available to download.", true);
                return;
            }

            // Flatten graph data to CSV rows
            const { dates, totalOdometer, totalDistance, totalSoConsumed } = graphData;
            const rows = dates.map((date, idx) => ({
                Date: date,
                "Total Odometer": totalOdometer[idx],
                "Total Distance": totalDistance[idx],
                "Total SoC Consumed": totalSoConsumed[idx],
            }));

            const stamp = moment().format("YYYYMMDD_HHmmss");
            JSONToCSVConvertor(rows, `Utilization_Graph_${stamp}`, false, true, false);
            toast("Download", `Utilization graph data downloaded (${stamp}).`);
        } else {
            toast("No Data", "Select a report type and fetch data before downloading.", true);
        }
    }

    getReport = () => {
        if (!this.isFormValid()) {
            return;
        }
        
        const { utilization_type, vehicleIds, startDate, endDate } = this.state;
        
        // Convert dates to timestamps
        const starttime = moment(startDate).unix() * 1000;
        const endtime = moment(endDate).unix() * 1000;
        
        // Prepare request body
        const body = {
            vehicleids: vehicleIds,
            utilization_type: utilization_type,
            starttime: starttime,
            endtime: endtime
        };
        
        // Set loading state
        this.setState({ busy: true, errorPage: false, tableData: [], columns: [], graphData: null });
        
        // Call appropriate API based on utilization_type
        if (utilization_type === "utilization-report") {
            ReportAPIs.getUtilizationReport(body)
                .then((response) => {
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0
                    });
                })
                .catch((error) => {
                    console.error("Utilization Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch utilization report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
        } else if (utilization_type === "utilization-graph") {
            ReportAPIs.getUtilizationReport(body)
                .then((response) => {
                    // Process response data for graph display
                    const graphData = this.processGraphData(response);
                    
                    this.setState({
                        graphData: graphData,
                        tableData: [],
                        columns: [],
                        busy: false,
                        errorPage: !graphData,
                        canDownload: !!graphData
                    });
                })
                .catch((error) => {
                    console.error("Utilization Graph Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        graphData: null,
                        tableData: [],
                        columns: [],
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Graph Failed",
                            content: "Failed to fetch utilization graph. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
        }
    }

    render(){
        return(
            <div className="monthlyReport">
                <div className="mrc-content">
                    <div className="mrcr-group">
                        <div className="mrcrg-selected">
                            <div className="mrc-select-all-toggle">
                                <label className="mrc-toggle-label">
                                    <input
                                        type="checkbox"
                                        checked={this.state.selectAllGroups}
                                        onChange={this.toggleSelectAllGroups}
                                        className="mrc-toggle-checkbox"
                                    />
                                    <span className="mrc-toggle-text">Select All Groups</span>
                                </label>
                            </div>
                            <div className={`mrcrgs-nav ${this.state.selectAllGroups ? 'disabled' : ''}`}>
                                <GroupNav
                                    props={this.state}
                                    navigate={this.navigate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mrc-controls-row">
                        <div className="mrcr-type" ref="reportContainer">
                            <div className="dropdown">
                                <div 
                                    className={this.state.dropdownOpen ? "dropdown-select-active" : "dropdown-select"} 
                                    onClick={this.toggleDropdown}
                                >
                                    {this.state.reportName ? this.state.reportName : "Select Report"}
                                </div>
                                {this.state.dropdownOpen && (
                                    <div className="dropdown-options">
                                        {this.getReportType()}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="mrc-date-selection">
                            <div className="mrcrd-picker">
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.startDate}
                                    onChange={(e) => this.handleStartDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="Start Date"
                                />
                            </div>
                            <div className="mrcrd-picker">
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.endDate}
                                    onChange={(e) => this.handleEndDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="End Date"
                                />
                            </div>
                        </div>
                        <div className="mrcr-download">
                            <button 
                                className={`mrcr-btn ${!this.isFormValid() ? 'disabled' : ''}`}
                                onClick={this.getReport}
                                disabled={!this.isFormValid()}
                            >
                                Get Report
                            </button>
                            <button 
                                className={`mrcr-btn-icon ${!this.state.canDownload ? 'disabled' : ''}`}
                                onClick={this.downloadReport}
                                title="Download"
                                disabled={!this.state.canDownload}
                            >
                                <i className="fa fa-download" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div className="mrc-table-section">
                        <div className="mrc-group-table">
                            {this.state.utilization_type === "utilization-graph" && this.state.graphData ? (
                                <ReusableGraph
                                    graphConfig={this.getGraphConfig()}
                                    height={600}
                                />
                            ) : null}
                            {this.state.utilization_type === "utilization-report" && this.state.tableData && this.state.tableData.length > 0 && this.state.columns.length > 0 ? (
                                <GroupTable
                                    data={this.state.tableData}
                                    columns={this.state.columns}
                                />
                            ) : null}
                            {this.state.busy ? (
                                <div className="mrc-table-loader">
                                    <div className="loading">Loading...</div>
                                </div>
                            ) : null}
                            {this.state.errorPage && !this.state.busy ? (
                                <div className="mrc-error-page">
                                    <div>NO DATA</div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default MonthlyReport;
